export class TemplateChoiceValue {
    id = 0;
    value = '';
    sortOrder = 0;
    templateChoiceTypeId = 0;
    orderChanged = false;
}
